import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ShActionItemComponent } from '../../elements/components/action-item/action-item.component';
import { ShIconModule } from '../../elements/components/icon/icon.module';

import { ShFormInputWithDroppanelModule } from '../../form-controls/components/_core/form-input-with-droppanel/form-input-with-droppanel.module';

import { ShFormDateSelectModule } from '../../form-controls/components/form-date-select/form-date-select.module';
import { ShFormDateModule } from '../../form-controls/components/form-date/form-date.module';
import { ShFormMultiSelectModule } from '../../form-controls/components/form-multi-select/form-multi-select.module';

import { ShFormTagListModule } from '../../form-controls/components/form-tag-list/form-tag-list.module';

import { ShClickOutsideDirective } from '../../elements/directives/click-outside/click-outside.directive';
import { ShGenericFilterItemComponent } from './base/components/filter-item/filter-item.component';
import { ShFilterBarComponent } from './components/filter-bar/filter-bar.component';
import { ShFilterDateComponent } from './components/filter-date/filter-date.component';
import { ShFilterMultiSelectComponent } from './components/filter-multiselect/filter-multiselect.component';
import { ShFilterTagSearchComponent } from './components/filter-tag-search/filter-tag-search.component';
import { ShFieldSearchComponent } from './containers/field-search/field-search.component';
import { ShSearchBarContainerComponent } from './containers/search-bar/search-bar.container.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ShIconModule,
        ShFormInputWithDroppanelModule,
        ShFormDateModule,
        ShFormMultiSelectModule,
        ShFormDateSelectModule,
        ShClickOutsideDirective,
        ShFormTagListModule,
        ShFieldSearchComponent,
        ShActionItemComponent,
        ShGenericFilterItemComponent,
        ShFilterMultiSelectComponent,
        ShFilterDateComponent,
        ShFilterTagSearchComponent,
        ShFilterBarComponent,
        ShSearchBarContainerComponent
    ],
    exports: [
        ShSearchBarContainerComponent,
        ShGenericFilterItemComponent,
        ShFilterMultiSelectComponent,
        ShFilterDateComponent,
        ShFilterTagSearchComponent,
        ShFilterBarComponent
    ]
})
export class ShSearchBarModule {}

export { ShGenericFilterItemComponent } from './base/components/filter-item/filter-item.component';
export { ShFilterBarComponent } from './components/filter-bar/filter-bar.component';
export { ShFilterDateComponent } from './components/filter-date/filter-date.component';
export { ShFilterMultiSelectComponent } from './components/filter-multiselect/filter-multiselect.component';
export { ShFilterTagSearchComponent } from './components/filter-tag-search/filter-tag-search.component';
export { ShSearchBarContainerComponent } from './containers/search-bar/search-bar.container.component';
